export const LogoMark = ({ className = "w-10 h-10" }) => (
  <svg viewBox="0 0 64 64" fill="none" className={className} xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
    <rect width="64" height="64" rx="14" fill="#0F141C" stroke="rgba(212,175,55,0.45)" />
    <path d="M14 42c5 8 11 12 18 12s13-4 18-12" stroke="#D4AF37" strokeWidth="4.5" strokeLinecap="round" />
    <path d="M23 36V25M32 36V16M41 36V28" stroke="#10B981" strokeWidth="4.5" strokeLinecap="round" />
    <path d="M20 20L32 9l12 11" stroke="#F3C649" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export const Wordmark = () => (
  <span className="flex items-center gap-3">
    <LogoMark className="w-9 h-9 shrink-0" />
    <span className="text-left leading-none">
      <span className="block font-display font-extrabold text-white text-sm sm:text-base tracking-wide">
        ALL IN HAND
      </span>
      <span className="block font-mono text-[9px] tracking-[0.42em] text-gold mt-1">MARKETING</span>
    </span>
  </span>
);
